<script>
import Layout from "../../../router/layouts/print";

/**
 * Screen component
 */
/* eslint-disable no-console */

export default {
  components: { Layout },
  data() {
    return { contract: null };
  },
   mounted() {
    // this.contract = {
    //       do_date: "ថ្ងៃទី១២ ខែមីនា ឆ្នាំ២០២៣",
    //       do_code: "NOLPC112-03032023",
    //       contract_code: "HSELL-03032023",
    //       contract_date: "ថ្ងៃទី១២ ខែមីនា ឆ្នាំ២០២៣",
    //       customer_name: "រិន ម៉ានេត",
    //       unit_code: "C1-12",
    //       unit_floor: "12",
    //       late_from_date: "ថ្ងៃទី១២ ខែមីនា ឆ្នាំ២០២២",
    //       gm: "",
    //   };
  },
  // watch: {
  //   data: function() {}
  // },
  watch: {
      data: function(newVal) { // watch it
        // console.log("AAAA", newVal);
        this.contract = newVal;

      }
  },
  methods: {},
  props: { data: null }
};
</script>
<template>
  <Layout>
        <center>
          
          <div class="col dblack box-a4-long khk">
            <p class="khm title l3" style="margin-top: 0.2cm;">ព្រះរាជាណាចក្រកម្ពុជា</p>
            <p class="khm h5 l4">ជាតិ សាសនា ព្រះមហាក្សត្រ</p>
            <p class="top-0">
              <img src="../../../assets/images/3symbol.svg" style="width: 150px;"/>
            </p>
            <table width="100%" class="doc-content">
              <tr>
                <td style="text-align: left;">
                  <img src="../../../assets/images/logoVertical.png" style="width: 200px;"/>
                </td>
                <td style="text-align: right;">
                  <span>ធ្វើនៅភ្នំពេញ, ថ្ងៃទី {{contract && contract.do_date}}</span><br>
                  លេខ : <span class="enb">{{contract && contract.do_code}}</span>
                </td>
              </tr>
            </table>
            <p class="khm sub-title top3" style="margin-top: -0px;">សេចក្តីជូនដំណឹង ស្តីពី</p>
            <p class="khm sub-title top3" style="margin-top: -0px;">ការរំលាយកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋាន</p>
            <p class="enb sub-title" style="margin-top: -15px; font-size: 12pt;">~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~</p>
  
            <table width="100%" class="doc-content top text-justify">
              <tr>
                <td width="10%"><p>&nbsp;</p></td>
                <td width="90%"><p>&nbsp;</p></td>
              </tr>
              <tr>
                <td>
                  <p class="khm">យោងៈ</p>
                </td>
                <td>
                  <p style="text-align: justify; line-height: 2em;">
                  - កិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋានលេខៈ {{contract && contract.contract_code}} ចុះថ្ងៃទី {{contract && contract.contract_date}}។ <br>
                  - សេចក្តីជូនដំណឹង ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ <span class="khm" style="font-weight: bold;">លើកទី១</span> លេខៈ {{contract && contract.inform1_code}} ចុះថ្ងៃទី {{contract && contract.inform1_date}}។ <br>
                  - សេចក្តីជូនដំណឹង ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ <span class="khm" style="font-weight: bold;">លើកទី២</span> លេខៈ {{contract && contract.inform2_code}} ចុះថ្ងៃទី {{contract && contract.inform2_date}}។ <br>
                  - សេចក្តីជូនដំណឹង <span class="khm" style="font-weight: bold;">ចុងក្រោយ </span>ស្តីពីការយឺតយ៉ាវបង់ប្រាក់ លេខៈ {{contract && contract.inform2_code}} ចុះថ្ងៃទី {{contract && contract.inform2_date}}។ <br>
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="2">
                  <p style="text-align: justify; text-indent: 10%; line-height: 2em">
                    <span class="khm" style="font-weight: bold;">ដោយហេតុថា</span> 
                    ឈ្មោះ <span class="khm" style="font-weight: bold;">{{contract && contract.customer_name}}</span> 
                    មិនមានឆន្ទៈពិតប្រាដកក្នុងការទូទាត់បំណុលដែលជំពាក់ថ្លៃទិញ យូនីកលេខៈ 
                    <span class="khm" style="font-weight: bold;">{{contract && contract.unit_code}} ជាន់ទីៈ {{contract && contract.unit_floor}}</span>
                    មានទីតាំងស្ថិតនៅអគារខុនដូ <span class="khm">លំនៅឋាន អេច សែនសុខ </span> 
                    លេខៈ ១២៥៥ ផ្លូវលេខៈ ១៩៧៨ ភូមិទំនប់ សង្កាត់ភ្នំពេញថ្មី ខណ្ឌសែនសុខ រាជធានីភ្នំពេញ និងបានរំលោភបំពានយ៉ាងធ្ងន់ធ្ងរលើកិច្ចព្រមព្រៀងលក់-ទិញលំនៅឋាន ដូចមានយោងមកខាងលើ ធ្វើឱ្យក្រុមហ៊ុនមានការខាតបង់យ៉ាងច្រើនដែលមិនអាចបន្តទៀតបាន ដូច្នេះក្រុមហ៊ុនសម្រេចរំលាយកិច្ចព្រមព្រៀងលក់-ទិញលំនៅ
                    លេខៈ {{contract && contract.contract_code}} ចុះថ្ងៃទី {{contract && contract.contract_date}} 
                    នេះចោលដោយឯកតោភាគីចាប់ពីថ្ងៃនេះតទៅ និងបើកលក់យូនីតខុនដូនេះឡើងវិញ ដោយមិនចាំបាច់ជូនដំណឹងទៅឈ្មោះ 
                    <span class="khm" style="font-weight: bold;">{{contract && contract.customer_name}}</span>
                    ម្តងទៀតឡើយ ។
                  </p>
                </td>
              </tr>
            </table>
            <br/>
            <table width="100%">
              <tr>
                <td width="70%"></td>
                <td width="30%"><p style="text-align: center; font-size: 12pt" class="khm">ប្រធានគ្រប់គ្រងទូទៅ</p></td>
              </tr>
              <tr>
                <td></td>
                <td>
                  <p>
                    <br/><br/><br/>
                  </p>
                  <p style="text-align: center; font-size: 12pt" class="khm">{{contract && contract.gm}}</p>
                </td>
              </tr>
            </table>
          </div>
        </center>
  </Layout>
</template>